// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-status[data-v-d0e44064]{height:24px;border-radius:12px;padding:0 var(--spacer-xs);font-size:10px;line-height:12px;letter-spacing:1px;font-weight:var(--font-weight-medium);text-transform:uppercase;background-color:var(--status-color);color:var(--v-white);cursor:default}.progress-status .v-icon[data-v-d0e44064]{margin-right:var(--spacer-4);width:16px;height:16px;color:var(--v-white);cursor:default}", ""]);
// Exports
module.exports = exports;
